<template>
  <div
    :class="[
      backgroundCustom ? 'main-container-custom' : 'main-container-default',
    ]"
    class="main-container"
    :style="[backgroundCustom ? {background: backgroundCustom} : '']"
  >
    <CRow
      class="title-container animate__animated animate__fadeIn justify-content-md-center"
    >
      <!--<CCol class="title-text" md="5" sm= "12">
          {{ $helpers.translate(title, lang) }}
        </CCol>-->
      <CCol class="sub-text mt-5 text-center col-md-7">
        <p class="main-description text-center">
          {{ $helpers.translate(description, 'th') }}
        </p>
        <p class="sub-description">
          {{ $helpers.translate(description, 'en') }}
        </p>
      </CCol>
      <CCol class="sub-text mt-5 text-right col-md-7">
        <button class="btn-primary enter-button m-auto" @click="enterCourse">
          เข้าสู่บทเรียน
        </button>
      </CCol>
    </CRow>

    <div
      v-show="imageContainerAppear"
      class="image-container animate__animated animate__fadeInUp"
    >
      <!--<img src="@/assets/images/CPR/Motion-Pulse.png" alt="">-->
      <img :src="this.baseUrl + '/cpr/Image/Motion-Pulse.gif'" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  props: {
    backgroundCustom: String,
    title: Array,
    link: String,
    description: Array,
  },
  data() {
    return {
      lang: 'th',
      baseUrl: process.env.VUE_APP_URL_SOUND,
      imageContainerAppear: false,
    };
  },
  methods: {
    enterCourse() {
      this.$router.push(this.link);
    },
  },
  mounted() {
    if (this.backgroundCustom) {
      this.imageContainerAppear = true;
    } else {
      setTimeout(() => {
        this.imageContainerAppear = true;
      }, 2000);
    }
  },
};
</script>

<style scoped>
@import '../../../assets/scss/CPR/style.scss';
.main-container-default {
  background: linear-gradient(180deg, #38adae, #cd295a);
  background-size: 400% 400%;
  animation: background 8s ease forwards;
  overflow-x: hidden;
  overflow-y: hidden;
  padding-top: 1.875rem;
  left: 0px;
  width: 100%;
  /* min-height: 100vh; */
  height: 100%;
  position: 0% 100%;
}

.main-container-custom {
  transition: all 0.5s;
  overflow: hidden;
  padding-top: 6.875rem;
  left: 0px;
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: auto;
}

@keyframes background {
  0% {
    background-position: 100% 0%;
  }
  100% {
    background-position: 0% 100%;
  }
}

.main-description {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 2px 2px 5px #00000029;
  width: 100%;
  display: inline-block;
  padding: 10px 20px;
  opacity: 1;
  font-weight: bold;
  font-size: 42px;
  color: rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  margin: 0 auto;
}

.sub-description {
  font-size: 58px;
  font-family: Roboto Medium;
  text-align: left;
  letter-spacing: 0px;
  color: #ffffff;
  text-shadow: 2px 2px 5px #00000029;
  opacity: 1;
  text-align: center;
  display: block;
  margin-top: 10px;
  width: 100%;
}

.title-text {
  text-align: end;
  font: Bold 155px/204px Roboto;
  letter-spacing: 0px;
  color: #ffffff;
  text-shadow: 2px 2px 5px #00000029;
  opacity: 1;
}

.enter-button {
  outline: none;
  padding: 0 1.25rem;
  /*padding-left: 1rem;*/
  /*padding-right: 1rem;*/
  margin-left: 14rem;
  margin-top: 4.375rem;
  text-align: left;
  font: Bold 30px/40px Sukhumvit Set;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
  /*background: transparent linear-gradient(202deg, #DBDBDB 0%, #E2E2E2 100%) 0% 0% no-repeat padding-box;*/
  box-shadow: -2px -2px 5px#CD295A4D;
  border-radius: 35px;
  /*opacity: 1;*/
  width: auto;
  height: 75px;
}

.image-container {
  position: relative;
  left: 0;
  margin-top: 51.84px;
  width: 100%;
  height: 30rem;
  background-position: center;
}

.image-container img {
  object-fit: cover;
  background-size: cover;
  width: 100%;
  height: 100%;
}

.title-container {
  animation-delay: 1s;
}

@media screen and (max-width: 768px) {
  .enter-button {
    font-size: 1.5rem;
  }
}

@media screen and (max-width: 480px) {
  .enter-button {
    /* margin: 0rem  */
    font-size: 1.5rem;
  }
}
</style>
